import styled from "styled-components";
import { Heading } from "@pepdirect/v3/ui/Heading";

export const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
`;

export const StyledShippingMethods = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
`;
